import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ReactNode } from "react";

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem={true}
      storageKey="genofx-theme"
      themes={["light", "dark", "dark-purple", "dark-blue"]}
    >
      {children}
    </NextThemesProvider>
  );
}
